import { DefaultTransition } from "./transistion.model";
import { DefaultCurrentRoute } from "./currentRoute.model";
export var DefaultRouteState = {
    RouteConfiguration: [],
    CurrentRoute: DefaultCurrentRoute,
    History: [],
    Transition: DefaultTransition
};
//# sourceMappingURL=route.state.js.map